import { NavLink } from 'react-router-dom';

import LeftMenu from '../../components/leftMenu';
import '../notice/noticeManage.css';
import './settlementStatement.css';

/** 정산명세서 PC 공통 틀(왼쪽 메뉴 + 본문). noticeBoardPc와 같은 구조다. */
export default function SettlementPcFrame({ storeNo, children }) {
  return (
    <>
      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>
            <NavLink to={`/${storeNo}/gift-list`}>홈</NavLink>
          </li>
          <li>정산명세서</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="settlement" />
          <section className="rightcontant_box notice-manage">{children}</section>
        </section>
      </main>
    </>
  );
}

/**
 * 주소의 storeNo와 로그인 상점을 비교해 표시할 안내를 정한다. 표시해도 되면 null.
 * 미로그인(401)은 useAxiosAdminFetch가 로그인 화면으로 보내므로 안내를 띄우지 않는다.
 */
export function accessMessage({ profile, status, isOwner }, urlStoreNo, messages) {
  if (!profile) return status === 401 ? '' : messages.error;
  if (String(profile.storeNo) !== String(urlStoreNo)) return messages.mismatch;
  if (!isOwner) return messages.forbidden;
  return null;
}
